<template>
	<div id="notification_registry_input" class="notification_registry" style="display:block">
		<div class="mb-3 flex-row" style="justify-content:space-between">
			<div class="mb3 flex-row">
				<label class="page-label">Уведомления</label>
			</div>
		</div>

		<div class="notification_registry__input">
			<div class="notification_registry__search-input">
				<div class="filter-table__input-wrap search-control">
					<input v-model="search"
                           @keyup.delete="onDeleteSearch()"
                           @keyup.enter="onSearch()"
                           type="text"
                           class="search-control__input form-control"
                           placeholder="Поиск"
                    >
					<button @click="onSearch()" class="search-control__input-btn reset-btn">
						<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M7.8 0C9.86869 0 11.8526 0.782651 13.3154 2.17578C14.7782 3.56891 15.6 5.45839 15.6 7.42857C15.6 9.26857 14.892 10.96 13.728 12.2629L14.052 12.5714H15L21 18.2857L19.2 20L13.2 14.2857V13.3829L12.876 13.0743C11.508 14.1829 9.732 14.8571 7.8 14.8571C5.73131 14.8571 3.74735 14.0745 2.28457 12.6814C0.821783 11.2882 0 9.39875 0 7.42857C0 5.45839 0.821783 3.56891 2.28457 2.17578C3.74735 0.782651 5.73131 0 7.8 0ZM7.8 2.28571C4.8 2.28571 2.4 4.57143 2.4 7.42857C2.4 10.2857 4.8 12.5714 7.8 12.5714C10.8 12.5714 13.2 10.2857 13.2 7.42857C13.2 4.57143 10.8 2.28571 7.8 2.28571Z" fill="currentColor"></path>
						</svg>
					</button>
				</div>
			</div>

			<div class="notification_registry__input-btns">
				<div>
					<button class="title-block__btn btn-mark-as-read btn-outline-primary btn"
						:disabled="checkedItems.indexOf(true) == -1"
						@click="readAll(checkedItems)">
                        Пометить все прочитанным
                    </button>
				</div>
			</div>
		</div>
	</div>

	<table class="service-table table align-middle">
		<thead>
			<tr>
				<th scope="col">
					<div class="form-check">
						<input
							class="form-check-input"
							type="checkbox"
							:value="isAllSelected"
							@change="toggleAll($event)"
						>
					</div>
				</th>
				<th scope="col" v-for="(elem, index) in thead" :key="index">
					<div :class="{'th-inner sortable asc': true, 'actions-row-label': elem === 'Действия'}">
						{{ elem }}
					</div>
				</th>
			</tr>
		</thead>
		<tbody>
            <tr v-for="(row, index) in tbody" :key="index">
                <td>
                    <div class="form-check">
                        <input
                            class="form-check-input"
                            type="checkbox"
                            v-model="checkedItems[index]"
                        >
                    </div>
                </td>
                <td :class="row.unread ? 'unread' : ''">{{ row.header }}</td>
                <td :class="row.unread ? 'unread' : ''">{{ row.priority }}</td>
                <td>
                    <div class="preview-column-element"
					:class="row.unread ? 'unread' : ''">
                        {{ row.preview }}
                    </div>
                </td>
                <td>
                    <div class="d-flex">
                        <button @click="toggleShowModal(row)" class="table-action table-action_preview m-auto align-middle" title="Предпросмотр"></button>
                        <button @click="toggleUnread(row)" class="table-action table-action_mark-as-read m-auto align-middle" title="Прочитано / не прочитано"></button>
                    </div>
                </td>
            </tr>
        </tbody>
	</table>
    <NotificationModal
        v-if="showModal"
        @closeModal="toggleShowModal"
        :modalTitle="modalTitle"
        :modalBody="modalBody"
    />

</template>

<script>
import NotificationModal from '../../../../modals/NotificationModal.vue';

export default {
    name: 'NotificationListComponent',
    components: {NotificationModal},
		props: {},
		data() {
			return {
				count: 1,
				limit: 30,
				page: 1,
				search: '',
				thead: ['Заголовок', 'Важность', 'Превью', 'Действия'],
				tbody: [
					{header: 'Технические работы', priority: 'Важное', preview: 'Текст 1', unread: true},
					{header: 'Технические работы 2', priority: '', preview: 'Текст 2', unread: true},
					{header: 'Технические работы 3', priority: 'Важное', preview: 'Уважаемые пользователи! В связи с проведением технических работ наш сайт будет временно недоступен. Пожалуйста, попробуйте зайти на него позже. Мы приносим свои извинения за неудобства.', unread: false},
					{header: 'Технические работы 4', priority: '', preview: 'Уважаемые пользователи! В связи с проведением технических работ наш сайт будет временно недоступен. Пожалуйста, попробуйте зайти на него позже. Мы приносим свои извинения за неудобства.', unread: false},
					{header: 'Технические работы 5', priority: 'Важное', preview: 'Уважаемые пользователи! В связи с проведением технических работ наш сайт будет временно недоступен. Пожалуйста, попробуйте зайти на него позже. Мы приносим свои извинения за неудобства.', unread: false},
					{header: 'Технические работы 6', priority: '', preview: 'Уважаемые пользователи! В связи с проведением технических работ наш сайт будет временно недоступен. Пожалуйста, попробуйте зайти на него позже. Мы приносим свои извинения за неудобства.', unread: false},
				],
				checkedItems: [],
                modalTitle: 'Технические работы',
                modalBody: 'Уважаемые пользователи! В связи с проведением технических работ наш сайт будет временно недоступен. Пожалуйста, попробуйте зайти на него позже. Мы приносим свои извинения за неудобства.',
                showModal: false,
				unread: true,
			};
		},
		computed: {
			isAllSelected() {
				return this.checkedItems.length === this.tbody.length && this.checkedItems.every(item => item);
			}
		},
		methods: {
			toggleAll(event) {
				const isChecked = event.target.checked;
				this.checkedItems = this.tbody.map(() => isChecked);
			},
			onSearch: async function () {
				this.page = 1;
				await this.loadTable();
			},
			onDeleteSearch: async function () {
				if (this.search.trim() === '') {
					this.page = 1;
					await this.loadTable();
				}
			},
            toggleShowModal: function (row) {
                if (!this.showModal) {
                    this.modalTitle = row.header;
                    this.modalBody = row.preview;
                    this.showModal = !this.showModal;
                } else {
                    this.showModal = !this.showModal;
                }
            },
			toggleUnread: function (row) {
				row.unread = !row.unread;
			},
			readAll: function (checkedItems) {
				this.tbody.forEach((row, index) => {
					if (checkedItems[index]) {
						row.unread = false;
					}
				});
			}
		},
		mounted() {}
	};
</script>

<style scoped lang="scss">
	th, td{
		vertical-align: middle;
	}
	.page-label {
		font-size: 18px;
		font-weight: 600;
	}
	.actions-row-label {
		text-align: center;
	}
	.notification_registry {
		margin: 0px 0px 20px 0px;
		&__input {
			display: flex;
			justify-content: space-between;
		}
		&__search-input {
			display: flex;
			flex-direction: row;
			align-items: center;
			gap: 16px;
			flex: 3;
		}
		&__input-btns {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: flex-end;
			gap: 16px;
			flex: 2;
		}
	}
	.letter-status {
		text-align: center;
		padding: 6px;
		border-radius: 6px;
		&__sent {
			background-color: #D4F8D3;
		}
		&__waiting {
			background-color: #D8EBFF;
		}
		&__error {
			background-color: #FBE7E9;
		}
	}
	.flex-row {
		display: flex;
		flex-direction: row;
		gap: 20px;
	}
    .hidden {
		display: none;
	}
	.visible {
		display: flex;
	}
	.preview-column-element {
		max-height: 60px;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	.unread {
		font-weight: bold;
	}
</style>
